import {Component, OnInit, Inject} from '@angular/core';
import {ClientNotificationService} from 'projects/desktop/src/app/view/notification/client-nfs-page/data/client-nfs.service';
import {ShortObject} from '../../../../data/project/short-json-object';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TasksService} from 'projects/desktop/src/app/modules/home-page/data/tasks/tasks.service';

@Component({
  selector: 'app-create-message-dialog',
  templateUrl: './create-message-dialog.component.html',
  styleUrls: ['./create-message-dialog.component.scss']
})
export class CreateMessageDialogComponent implements OnInit {

  types: ShortObject[];
  selectedType: ShortObject;
  loadingSpinner: boolean;

  id: number;
  type: string;

  constructor(
    private snackBar: MatSnackBar,
    protected clientNotificationService: ClientNotificationService,
    protected tasksService: TasksService,
    @Inject(MAT_DIALOG_DATA) public data: {
      type: string,
      id: number

    },
    protected dialogRef: MatDialogRef<CreateMessageDialogComponent>
  ) {
    this.id = data.id
    this.type = data.type
  }

  ngOnInit(): void {
    let service = this.clientNotificationService.getConditionTypes()
    if (this.type === 'taskNfs') {
      service = this.tasksService.getConditionTypes()
    }

    service.subscribe(types => {
      this.types = types;

      if (this.type === 'taskNfs') {
        const fType = this.types.find(type => type.name === 'Service visit notification');
        if (fType) {
          this.selectedType = fType
        } else {
          this.selectedType = this.types[0];
        }
      } else {
        this.selectedType = this.types[0];
      }


    })
  }

  createMessageButton() {
    this.loadingSpinner = true;
    let service = this.clientNotificationService.createMessage(this.id, this.selectedType.id)
    if (this.type === 'taskNfs') {
      service = this.tasksService.createMessage(this.id, this.selectedType.id)
    }

    service.subscribe(result => {
      this.loadingSpinner = false;
      result.project = {
        id: result.projectId,
        name: result.projectName
      }
      this.dialogRef.close(['success', result]);
    }, error => {
      this.loadingSpinner = false;
      this.openSnackBar(error.message)
    })
  }

  openSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

}
